const state = {
    // socketIsRunning: false,
    m2mMsg:{},
    semiAutoLabelMsg:{}
}


export default {
    state
}